import React from 'react';
import {Link}  from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

interface NewsSurveysStateBarProps{
    selected: string;
}

const NewsSurveysStateBar: React.FC<NewsSurveysStateBarProps> = ({selected})=>{

  const buttons = [
    {id: 1, name: 'Recursos', state: 'Noticias', url: "/admin/dashboard/noticias"},
    {id: 2, name: 'Capacitaciones', state: 'Capacitaciones', url: "/admin/dashboard/capacitaciones"},
    {id: 3, name: 'Reportes', state: 'Reportes', url: "/admin/dashboard/reportes-recursos"}
  ]


  return (
    <Grid item xs={12} className="state-bar-container">
      <Grid container item xs={12} className="container-buttons">
        {buttons.map(item=>(
          <Link key={item.id}  to={item.url} className="link-state-bar">
            <div className={selected === item.state ? 'button-definition-active' : 'button-definition'}>
              <Typography variant="h5" className="regular-serif">
                {item.name}
              </Typography>
            </div>
          </Link>
        ))}
      </Grid>
    </Grid>
  )
}

export default NewsSurveysStateBar;
